// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { NumericLinks } from '@shared/commons/cache/OrderParams/order-edit/OrderEditBase';
import { OrderEditBaseUtils } from '@shared/utils/Trading/OrderEditBaseUtils';
import { SlTpUtils } from '@shared/utils/Trading/SlTpUtils';
import DPTradingNumericTemplate from '@front/templates/DPTradingNumericTemplate.html';
import { DynPropertyControl } from '../elements/DynPropertyControl';
import { BaseSettings } from '@shared/commons/Settings/BaseGeneralSettingsWrapper';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
// TODO. Mousewheel increment bug, value validation bug.
export class DPTradingNumeric extends DynPropertyControl {
    constructor() {
        super();
        this.valueUpDownChangeProcess = (isUp, price) => {
            const ins = this.get('instrument');
            const incrementCoeff = this.get('insIncrementCoeff');
            const ticks = incrementCoeff * (isUp ? 1 : -1);
            const newPrice = ins.calculatePrice(price, ticks, true);
            return newPrice;
        };
    }
    getType() {
        return ControlsTypes.DPTradingNumeric;
    }
    oncomplete() {
        super.oncomplete();
        const numericLinkKey = this.get('name') === OrderEditBaseUtils.LIMIT_PRICE_PARAM
            ? NumericLinks.LimitPrice
            : NumericLinks.StopPrice;
        void this.set(numericLinkKey, this.Controls.TradingNumeric);
        this.observe('instrument name', this.updateIncrementCoefficient);
        BaseSettings.insDefSettingsStorage.DefaultSettingsChanged.Subscribe(this.updateIncrementCoefficient, this);
    }
    onteardown() {
        BaseSettings.insDefSettingsStorage.DefaultSettingsChanged.UnSubscribe(this.updateIncrementCoefficient, this);
        super.onteardown();
    }
    isTrailingStop() {
        return this.get('name') === OrderEditBaseUtils.TRAILING_STOP_PARAM;
    }
    onNameChanged() {
        const instrument = this.get('instrument');
        if (this.isTrailingStop()) {
            const numericRightAlignedText = SlTpUtils.getSymbolForOffsetMode(SlTpUtils.getDefaultVisualOffsetTypeExcludePercent(instrument, BaseSettings.offsetType));
            void this.set('rightAlignedText', numericRightAlignedText);
        }
        else {
            void this.set('rightAlignedText', '');
        }
    }
    updateIncrementCoefficient() {
        var _a;
        if (this.isTrailingStop()) {
            this.set('insIncrementCoeff', 1);
            return; /* #131848 */
        }
        const instrument = this.get('instrument');
        const insDefSettings = BaseSettings.insDefSettingsStorage.GetInstrumentSettings(instrument);
        this.set('insIncrementCoeff', (_a = insDefSettings === null || insDefSettings === void 0 ? void 0 : insDefSettings.PriceIncrementTicks) !== null && _a !== void 0 ? _a : 1);
    }
}
DynPropertyControl.extendWith(DPTradingNumeric, {
    template: DPTradingNumericTemplate,
    data: function () {
        return {
            instrument: null,
            showLabel: true,
            PriceNumericLink: null,
            StopPriceNumericLink: null,
            rightAlignedText: '',
            rightAlignedTextAdditionalClass: '',
            width: 200,
            additionalClassName: '',
            insIncrementCoeff: 1
        };
    }
});
